import {
  Title as DefaultTitle,
  Modal as DefaultModal,
} from '@getinapp/appetizer';
import styled, { css } from 'styled-components';

export const Title = styled(DefaultTitle)`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.large} !important;
  `}
`;

export const Paragraph = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.highContrast};
    font-size: 1.5rem;
  `}
`;

export const Small = styled.small`
  ${({ theme }) => css`
    display: block;
    font-size: ${theme.font.sizes.xsmall};
    color: ${theme.colors.primary};
    margin: 0.5rem 0 2.7rem;
  `}
`;

export const Modal = styled(DefaultModal)`
  background: white;

  button {
    ${({ theme }) => css`
      color: ${theme.colors.white};
    `}
  }
`;

export const Checkbox = styled.div`
  user-select: none;
  margin-top: 1.5rem;

  input {
    cursor: pointer;
  }

  label {
    margin-left: 0.5rem;
  }

  ${({ theme }) => css`
    span,
    a {
        color: ${theme.colors.primary};
      }
    }
    font-size: ${theme.font.sizes.small};
  `}
`;

export const Error = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.error};
    font-size: ${theme.font.sizes.xsmall};
  `}
`;

export const SelectWrapper = styled.div`
  margin-top: 0.55rem;
  label {
    position: absolute;
    padding: 0 0.35rem;
    ${({ theme }) => css`
      color: ${theme.colors.black};
      background: ${theme.colors.white};
    `}
    transition: all 0.2s ease-in-out;
    transform-origin: left top;
    cursor: text;
    pointer-events: none;
    transform: translate3d(0, -45.5%, 0) scale(0.9);
    margin-left: 15px;
    font-size: 1.3rem;
    z-index: 10;
  }

  select {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    padding: 0.7rem 1rem;
    padding-top: 1rem;
    padding-left: 1rem;
    padding-right: 3rem;
    outline: none;

    background: transparent;
    background-position-x: 244px;

    ${({ theme }) => css`
      font-family: ${theme.font.family};
      font-style: normal;
      font-weight: normal;
      font-size: 1.5rem;
      border: none;
      width: 100%;
      border-radius: ${theme.border.radius.large};

      &::placeholder {
        color: ${theme.colors.contrast};
        transition: opacity 0.2s cubic-bezier(0.6, 0.04, 0.98, 0.335);
      }

      display: flex;
      align-items: center;
      border: 1px solid ${theme.colors.black};
      border-radius: ${theme.border.radius.large};

      option {
        background: transparent;
      }
    `}
  }
`;

export const BackButton = styled.p`
  margin-top: 1.5rem;
  ${({ theme }) => css`
    color: ${theme.colors.highContrast};
    font-size: 1.5rem;

    &:hover {
      cursor: pointer;
    }
    span {
      margin-right: 1rem;
    }
  `}
`;
